// src/components/Navbar.jsx
import React, { useState, useRef, useEffect } from "react";
import { NavLink, useNavigate, useLocation, Link } from "react-router-dom";
import {
  Navbar,
  Nav,
  Button,
  Form,
  FormControl,
  Container,
  Image,
  Dropdown,
} from "react-bootstrap";
import { FaSearch, FaRegUser } from "react-icons/fa";
import COLORS from "../styles/colors.js";
import logo from "../assets/Logo.png";
import TopicsDropdown from "./TopicsDropdown";
import "../styles/Navbar.css";


function HeaderNavbar({ scrollToSection }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [navExpanded, setNavExpanded] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Keep search term from URL
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const urlSearchTerm = searchParams.get("q") || "";
    setSearchTerm(urlSearchTerm);
  }, [location.search]);

  const performSearch = () => {
    const trimmed = searchTerm.trim();
    if (trimmed) {
      navigate(`/home?q=${encodeURIComponent(trimmed)}`);
    } else {
      navigate("/home");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      performSearch();
    }
  };

  return (
    <Navbar
      expand="lg"
      expanded={navExpanded}
      onToggle={(next) => setNavExpanded(next)}
      className="navbar-custom sticky-top py-3 w-100 shadow-sm"
    >
      <Container>
        {/* Logo */}
        <Navbar.Brand as={Link} to="/" className="me-4 d-flex align-items-center">
          <Image src={logo} alt="TalkShow" height="40" />
        </Navbar.Brand>

        {/* Toggle for mobile */}
        <Navbar.Toggle aria-controls="navbar-nav" />

        <Navbar.Collapse id="navbar-nav" className="justify-content-between">
          {/* Left Links */}
          <Nav className="nav me-auto align-items-lg-center">
            <Nav.Link
              as={NavLink}
              to="/"
              end
              className={({ isActive }) =>
                isActive ? "active-link me-4" : "me-4"
              }
            >
              Home
            </Nav.Link>

            <Nav.Link
              as={NavLink}
              to="/news"
              className={({ isActive }) =>
                isActive ? "active-link me-4" : "me-4"
              }
            >
              Talk Shows
            </Nav.Link>

            <TopicsDropdown
              navExpanded={navExpanded}
              setNavExpanded={setNavExpanded}
              className={({ isActive }) =>
                isActive ? "active-link me-4" : "me-4"
              }
            />

            <Nav.Link
              as={NavLink}
              to="/myshows"
              className={({ isActive }) =>
                isActive ? "active-link me-4" : "me-4"
              }
            >
              My Shows
            </Nav.Link>

            <Nav.Link
              as={NavLink}
              to="/about"
              className={({ isActive }) =>
                isActive ? "active-link me-4" : "me-4"
              }
            >
              About
            </Nav.Link>

            
          </Nav>

          {/* Right Section */}
          <div className="button-section d-flex align-items-center gap-2 flex-wrap">
            {/* Search */}
            <Form className="search d-flex align-items-center" onSubmit={(e) => e.preventDefault()}>
              <div
                className="input-group"
                style={{
                  backgroundColor: COLORS.light_gray,
                  borderRadius: "5px",
                  overflow: "hidden",
                }}
              >
                <span
                  className="input-group-text border-0"
                  style={{
                    backgroundColor: COLORS.light_gray,
                    color: COLORS.text_muted,
                  }}
                >
                  <FaSearch />
                </span>
                <FormControl
                  type="search"
                  placeholder="Search talk shows..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  onKeyDown={handleKeyDown}
                  className="border-0 no-focus-outline"
                  style={{
                    backgroundColor: COLORS.light_gray,
                    color: COLORS.text_muted,
                    width: "200px",
                  }}
                />
              </div>
            </Form>

            {/* Buttons group */}
            <div className="buttons-group d-flex gap-2">
              <Button
                className="px-3"
                onClick={() => navigate("/chat-bot")}
                style={{
                  backgroundColor: COLORS.blue,
                  border: "none",
                  fontSize: "14px",
                  fontWeight: "500",
                  height: "38px",
                }}
              >
                Ask the Chatbot
              </Button>

              <Dropdown align="end" className="login-dropdown-container">
                <Dropdown.Toggle as={Button} style={{ justifyContent: "center" , height: "38px"}} className="toggle-button">
                  <FaRegUser style={{ fontSize: '14px' }} />
                </Dropdown.Toggle>

                <Dropdown.Menu className="login-dropdown">
                  <Dropdown.Item onClick={() => navigate('/user-login')}>Login / Logout</Dropdown.Item>
                  <Dropdown.Item onClick={() => navigate('/create-account')}>Create Account</Dropdown.Item>
                  
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>

        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default HeaderNavbar;
